<template>
  <div v-if="is_from_mobile == 1">
    <button class="navbar-toggler !rounded-r-full overflow-hidden relative -left-3" type="button"
      data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar"
      aria-label="Toggle navigation">
      <div class="flex items-center gap-2 py-2 px-3 !bg-[#A084E8]">
        <img src="../assets/images/plan-nav-icon.png" alt="Plan Icon" class="w-5 h-5 object-contain">
        <span class="text-[16px] text-[#fff]">Plans</span>
      </div>
    </button>
    <div id="offcanvasNavbar" class="offcanvas offcanvas-start  h-max !w-full" tabindex="-1"
      aria-labelledby="offcanvasNavbarLabel" data-bs-scroll="false" data-bs-backdrop="true">
      <button type="button" class="absolute top-0 right-0 w-7 h-10 !rounded-l-full !bg-red-400 translate-y-14"
        data-bs-dismiss="offcanvas" aria-label="Close">
        <i class="fa fa-angle-left !text-[20px] text-[#fff]" aria-hidden="true" />
      </button>
      <div class="offcanvas-body rounded-[10px] m-3 w-[85%]">
        <mobileSidebarNavigation />
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:pt-0 laptop:pt-5 largeDesktop:grid-cols-3 mobile:grid-cols-1 items-center gap-5">
      <div class="mobile:hidden tablet:hidden laptop:hidden desktop:block largeDesktop:block">
        <!-- Figma 5689-6372: breadcrumb pill at the left edge (the header logo no longer overlaps this row) -->
        <ol v-if="isBreadcrumbShow"
          class="flex items-center p-2 rounded-full w-max max-w-full m-0 text-[13px] largeDesktop:text-[14px] whitespace-nowrap bg-opacity-80 bg-white">
          <!-- Work Order | Appointments (list) · Work Order | Appointments | 19216 (detail); no Dashboard crumb -->
          <!-- on narrow desktops only the middle (section) crumb shortens; "Work Orders" and the id always show -->
          <li v-for="(crumb, index) in crumbs" :key="index" class="px-2" :class="[index > 0 ? 'border-l border-[#666666]' : '', index === crumbs.length - 1 ? 'text-[#666666]' : 'text-[#8479E1]',
          index > 0 && index < crumbs.length - 1 ? 'min-w-0 truncate' : 'flex-shrink-0']">
            <router-link v-if="crumb.to && index < crumbs.length - 1" :to="crumb.to"
              class="no-underline text-[#8479E1]" @click="markMenuNav">{{ crumb.label }}</router-link>
            <template v-else>{{ crumb.label }}</template>
          </li>
        </ol>
      </div>
      <div class="w-3/4 laptop:w-full largeDesktop:w-full mx-auto mobile:hidden laptop:block largeDesktop:block">
        <globalSearch v-model="search"
          :input-class="'rounded-full shadow-[0px_0px_10px_0px_#0000001A] pl-3 !pr-20 laptop:py-2 largeDesktop:py-2.5 w-full laptop:h-[38px] largeDesktop:h-[45px] bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none '"
          :buttonclass="'absolute top-[2.5px] right-[3px] largeDesktop:top-[2px] largeDesktop:right-[3px] laptop:w-8 laptop:h-8 largeDesktop:w-10 largeDesktop:h-10'"
          :clear-class="'absolute top-0 flex items-center justify-center !h-[100%] right-[3.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
          :clearable="true" :on-enter="handleSearch" :on-clear="handleClear" :readonly="loading" />
      </div>
      <div class="relative flex items-center mobile:justify-center laptop:justify-end"
        :class="$route.name == 'globalSearch' ? 'h-10' : 'h-0'">
        <a v-if="$route.name == 'globalSearch'"
          class="absolute top-[50px] left-0 cursor-pointer w-10 h-10 p-2 rounded-full flex items-center justify-center laptop:!hidden bg-gradient-to-r from-[#16BCFF] to-[#168EFF]"
          @click="backButton()">
          <img src="../assets/images/back-arrow-icon.png" alt="Back Arrow Button" class="w-full h-full">
        </a>
        <div
          class="flex mobile:justify-center tablet:justify-center laptop:justify-end largeDesktop:justify-end gap-3 items-center">
          <!-- the targets live in the header, which the mobile app webview (is_from_mobile=1) does not render:
               a Teleport without its target breaks every later re-render of the page -->
          <Teleport v-if="$route.query.is_from_mobile != 1" defer :to="isLaptop ? '#headerCreateQuote' : '#headerCreateQuoteMobile'">
            <createQuote
              :itemList="createQuoteList.filter(i => i.id != 1 || !Number(userObject?.user?.is_dealer_for_partner))"
              @event="actionClicked" :button-warpper-class="'relative inline-block text-left'"
              :button-class="'flex items-center mobile:gap-2 laptop:gap-3 mobile:px-1.5 laptop:px-3 py-1.5 laptop:py-2 border border-gray-100 bg-gray-100 text-gray-900 rounded-full relative group hover:!bg-teal-500 hover:!border-teal-500 transition-all'"
              :button-text-class="'font-roboto text-[16px] text-gray-900 whitespace-nowrap group-hover:!text-white mobile:hidden tablet:inline'"
              :button-icon-class="'relative w-[18px] laptop:w-[20px] h-[18px] laptop:h-[20px] object-contain'"
              :dropdown-list-class="isLaptop ? 'origin-top-right fixed mt-[10px] w-52 rounded-md shadow-lg z-[1060] bg-white' : 'origin-top-right fixed !p-0 !m-0 !left-auto right-[12px] top-[70px] !w-max max-w-[calc(100vw-24px)] rounded-md shadow-lg z-[1060] bg-white'"
              :dropdown-list-l-i-class="'rounded-md overflow-hidden hover:bg-gray-200'"
              :dropdown-list-anchor-class="'font-roboto block px-2 py-2 text-sm no-underline cursor-pointer text-gray-700 hover:bg-gray-200'" />
          </Teleport>
        </div>
      </div>
    </div>
  </div>
  <!-- Contractor Modal Modal -->
  <div id="contractorModal" ref="contractorModal" class="modal fade" tabindex="-1" aria-labelledby="contractorModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered tablet:w-[500px] !absolute !right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative h-[100px]">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <img src="../assets/images/profile-bg.png" class="w-full object-contain absolute left-0 top-0"
                alt="backgroundImage">
              <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                  Details
                </h6>
                <img src="../assets/images/nrg-logo.png" alt="contractor Logo" class="w-14 h-14 object-contain">
              </div>
            </div>
          </div>
          <div class="max-h-[90vh] overflow-y-auto customScrollbar mt-4">
            <companyDetailDropdown />
          </div>
        </div>
      </div>
    </div>
  </div>
  <addUniverslQuote ref="createQuoteRef" />
  <CreateRepairJob ref="createRepairJobRef" />
</template>

<script>
import { detailTrail, markMenuNav, saveCrumbs } from "@/helpers/crumbTrail";
import { Modal } from "bootstrap";
import globalSearch from './partialComponent/customInput.vue';
import companyDetailDropdown from "./companyDetailModal.vue"
import createQuote from "./partialComponent/createQuote.vue"
import addUniverslQuote from "../components/workOrder/addUniverslQuote.vue";
import CreateRepairJob from "./booking/CreateRepairJob.vue";
import {
  mapGetters, mapActions
} from "vuex";
import router from "../router";
import { rqApi } from "../services/rqApi";
import { useToast } from "vue-toastification";
const toast = useToast();
import { menuRouteFor, withTechMenu } from "../helpers/techMenu";
import mobileSidebarNavigation from "./mobileSidebarNavigation.vue";

// detail pages named by their record, for "Appointment ID: 19337" in a trail (helpers/crumbTrail)
const RECORD_NAMES = {
  "/work-order/appointment": "Appointment",
  "/work-order/service-and-repair": "Service & Repair",
  "/work-order/replacement-quote": "Replacement Quote",
  "/work-order/universal-quotes": "Universal Quote",
};

export default {
  components: {
    globalSearch,
    createQuote,
    companyDetailDropdown,
    addUniverslQuote,
    CreateRepairJob,
    mobileSidebarNavigation,
  },
  data() {
    return {
      search: '',
      loading: false,
      isSquare: null,
      is_from_mobile: localStorage.getItem("is_from_mobile", 0) ?? 0,
      // laptop breakpoint (tailwind 1024px): where Create Quote is teleported in the header
      isLaptop: window.matchMedia("(min-width: 1024px)").matches,
      createQuoteList: [
        {
          id: 1,
          title: "Service & Repair",
        },
        {
          id: 2,
          title: "Replacement Quote",
        },
        {
          id: 3,
          title: "Universal Quote",
        }
      ],

    }
  },
  computed: {
    ...mapGetters(["userObject", "sideMenuData"]),
    isBreadcrumbShow() {
      // Dashboard is home: no breadcrumb there (Figma)
      if (this.$route.name == "globalSearch" || this.$route.name == "dashboard") {
        return false
      }
      return this.crumbs.length > 0
    },
    // Breadcrumb = the page's path in the sidebar menu (e.g. Partner | NRG Protects | HVAC, Work Orders | Appointments).
    // Detail pages add the record id after their list (Work Orders | Appointments | ID: 19216). No Dashboard crumb.
    crumbs() {
      const menu = withTechMenu(Array.isArray(this.sideMenuData) ? JSON.parse(JSON.stringify(this.sideMenuData)) : []);
      const isLink = (route) => route && route !== '#';
      // chain of menu items from the top level down to the first item matching `test`
      const chainTo = (items, test, parents = []) => {
        for (const item of items || []) {
          const chain = [...parents, item];
          if (test(item)) return chain;
          const found = chainTo(item.submenu, test, chain);
          if (found) return found;
        }
        return null;
      };
      const toCrumbs = (chain) => chain.map(item => ({ label: item.name, to: isLink(item.route) ? item.route : null }));

      const route = this.$route;
      // RQ data sheet / system summary have their own breadcrumb bar on the page
      if (['rq-data-sheet', 'rq-summary', 'rq-summary-edit'].includes(route.name)) return [];
      const listPath = menuRouteFor(route);
      const isDetail = listPath !== route.path;
      const chain = chainTo(menu, item => item.route === listPath);
      if (chain) {
        const crumbs = toCrumbs(chain);
        if (isDetail && route.params.id) crumbs.push({ label: "ID: " + route.params.id });
        // opened from a record's detail by an in-page action (S&R → Universal Quotes, UQ → View Appointment, linked job):
        // keep that detail's path and add this page — a list by its name, a detail as "<record> ID: …" with no list
        // crumb: Work Orders | Universal Quotes | ID: 5835 | Appointment ID: 19337 (helpers/crumbTrail)
        this.saveOwnCrumbs(crumbs);
        const trail = detailTrail();
        // the same record's own page (job detail → Select a Unit / View Evaluation …) is not another record: no trail
        const sameRecord = trail && isDetail && trail[trail.length - 1].label === "ID: " + route.params.id
          && trail.some(c => c.label === crumbs[chain.length - 1].label);
        if (trail && !sameRecord) {
          const section = crumbs[chain.length - 1].label;
          if (!isDetail) return [...trail, { label: section }];
          return [...trail, { label: `${RECORD_NAMES[listPath] || section} ID: ${route.params.id}` }];
        }
        return crumbs;
      }
      // partner pages that are not menu items (products, plan pages …): parent section of that partner + page name
      if (route.params.partnerSlug) {
        const leaf = chainTo(menu, item => isLink(item.route) && item.route.includes(`/${route.params.partnerSlug}/`));
        if (leaf) return [...toCrumbs(leaf.slice(0, -1)), { label: this.getPageName() || 'Plans' }];
      }
      // pages that are not in the side menu (Messages, Payment Method, …): no breadcrumb
      return [];
    },
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.search = this.$route.query.q
        }
      },
    },
  },

  mounted() {
    // the "+" on the S&R / RQ / UQ lists runs the same create item as this Create Quote menu (1 S&R, 2 RQ, 3 UQ)
    // detail: the item id, or { item: 3, preset } for a UQ from an S&R job (consumer + source already known)
    this.onListCreate = (e) => (e.detail?.preset ? this.addUnversalQuote(e.detail.preset) : this.actionClicked(null, e.detail));
    window.addEventListener("fx-create", this.onListCreate);
    this.laptopMq = window.matchMedia("(min-width: 1024px)");
    this.onLaptopChange = (e) => { this.isLaptop = e.matches; };
    this.laptopMq.addEventListener("change", this.onLaptopChange);
    const observer = new MutationObserver(() => {
      const offcanvas = document.getElementById('offcanvasNavbar');
      if (offcanvas.classList.contains('show')) {
        document.documentElement.style.overflow = 'hidden'; // <html>
      } else {
        document.documentElement.style.overflow = '';
      }
    });

    const targetNode = document.getElementById('offcanvasNavbar');
    if (targetNode) {
      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  },

  beforeUnmount() {
    window.removeEventListener("fx-create", this.onListCreate);
    if (this.laptopMq) this.laptopMq.removeEventListener("change", this.onLaptopChange);
  },
  methods: {
    markMenuNav,
    // the page's own path for the next page's trail (helpers/crumbTrail); after render so history.state is this entry
    saveOwnCrumbs(crumbs) {
      const own = crumbs.map(c => ({ ...c }));
      this.$nextTick(() => saveCrumbs(own));
    },
    ...mapActions(["getProfile"]),
    actionClicked(action, item) {
      if (item == 1) {
        // Android "Create a Repair Job" (CreateBookingFragment)
        this.$refs.createRepairJobRef.showModal();
      }
      else if (item == 2) {
        this.addRQ()
      }
      else if (item == 3) {
        this.addUnversalQuote()
      }
    },
    // one active job at a time, then the native Create Replacement Quote flow (/rq/*)
    async addRQ() {
      if (this.creatingRQ) return
      this.creatingRQ = true
      try {
        const guard = await rqApi.singleActiveRecord();
        if (!guard.ok) {
          const active = guard.activeRecord;
          if (!active) {
            toast.error(guard.message);
            return
          }
          const rec = active.active_record || {};
          // the same small confirmation popup as everywhere else (no 60% modal)
          this.$dialog.show({
            title: 'Dispositioned Leads',
            text: active.message,
            buttonText: rec.button_text || 'Resolve',
            onConfirm: () => {
              if (!rec.id) return
              const paths = { appointment: '/appointment/detail/', booking: '/job/detail/' };
              this.$router.push((paths[rec.type] || '/replacement-quote/detail/') + rec.id);
            },
          });

          return
        }
        const res = await rqApi.allowCreate();
        if (!res.ok || !res.body?.is_allow) {
          toast.error(res.message || "You can't create a replacement quote right now.");
          return
        }
        this.$router.push('/rq/consumer');
      } finally {
        this.creatingRQ = false
      }
    },
    addUnversalQuote(preset = null) {
      this.$refs.createQuoteRef.showModal(preset);
    },
    checkImageShape() {
      const img = this.$refs.logoImage;
      if (img && img.naturalWidth && img.naturalHeight) {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        const ratio = width / height;

        // Consider it square if width and height differ by no more than ±10%
        this.isSquare = ratio >= 0.9 && ratio <= 2;
      }
    },

    backButton() {
      this.$router.go(-1);
    },
    contractorModal() {
      this.modal = new Modal(this.$refs.contractorModal);
      this.modal.show();
    },
    getPageName() {
      if (['appointment', 'serviceRepair', 'replacementQuote', 'universalQuotes'].includes(this.$route.name)) {
        return 'Work Orders'
      } else if (this.$route.name == 'checkoutDetail') {
        return 'Payment Method'
      } else if (this.$route.name == 'messages') {
        return 'Messages'
      } else if (['AppointmentDetail', 'appointment-members'].includes(this.$route.name)) {
        return 'Appointments'
      } else if (['rq-detail', 'rq-data-sheet', 'rq-summary', 'rq-summary-edit'].includes(this.$route.name)) {
        return 'Replacement Quote History'
      } else if (['QuoteDetail', 'QuoteEdit', 'quote-members'].includes(this.$route.name)) {
        return 'Universal Quotes'
      } else if (['job-detail', 'job-members', 'select-unit', 'last-evaluation', 'equipment', 'initial-check', 'summary', 'edit-summary', 'final-evaluation', 'summary-detail', 'job-invoice', 'view-evaluation'].includes(this.$route.name)) {
        return 'Service & Repair'
      } else if (this.$route.name == 'salesHistory') {
        return 'Sales History'
      } else if (this.$route.name == 'commisionAmount') {
        return 'Commissions'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else {
        return ''
      }

    },
    setLoading() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 200);
    },
    handleClear() {
      this.search = ''
      this.handleSearch()
    },
    handleSearch() {
      let search = ""
      search = this.$helper.isEmpty(this.search) ? '' : this.search.trim()
      this.setLoading()
      if (this.$route.name == 'globalSearch') {
        this.$router.replace({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      } else {
        this.$router.push({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      }
    }

  },
};
</script>